import SlideOverAddCompany from 'components/SlideOver/dataSlideOver/data/slideOverCompany/slideOverAddCompany';
import UseContext from 'hooks/useContext';

export const COMPLETE_CLIENT_PANEL = 'complete_client';

/**
 * « Compléter la fiche client » (slide-over `complete_client`): « Passer
 * client » on a prospect's page opens the form of a client company on it
 * (`objID`), filled with what the prospect has. Every field the creation asks
 * for must be filled before « Passer en client ».
 */
const CompleteClientPanel = () => {
  const { objID } = UseContext();
  return <SlideOverAddCompany completeCompanyId={objID ? String(objID) : null} />;
};

export default CompleteClientPanel;
